import React from "react";
import styled from "styled-components";

const Number = ({ number, borderColor }) => {
  return <NumberContainer borderColor={borderColor}>12 points</NumberContainer>;
};

export default Number;

const NumberContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`;
